// Centralized smooth-scroll helper.
// Uses the shared Lenis instance (exposed on window by App.js) so programmatic
// scrolling is driven by Lenis itself instead of native scrollIntoView, which
// Lenis would otherwise override (breaking e.g. mobile menu navigation).
export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  const lenis = typeof window !== "undefined" ? window.__lenis : null;
  if (lenis && typeof lenis.scrollTo === "function") {
    lenis.scrollTo(el, { offset: -80 });
  } else {
    el.scrollIntoView({ behavior: "smooth", block: "start" });
  }
};
